import React from 'react';
interface CometCardProps {
  children: React.ReactNode;
  className?: string;
}
const CometCard: React.FC<CometCardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`relative p-[1px] ${className}`} data-id="element-36">
      {/* Comet Animation Layer */}
      <div className="absolute inset-0 rounded-[17px] overflow-hidden pointer-events-none" data-id="element-37">
        <div className="absolute w-24 h-[2px] bg-gradient-to-r from-transparent via-white to-transparent opacity-80 blur-[1px]" style={{
        offsetPath: 'rect(0% auto 100% 0% round 17px)',
        animation: 'comet-orbit 4s linear infinite'
      }} data-id="element-38" />
      </div>

      {/* Content */}
      <div className="relative z-10" data-id="element-39">{children}</div>
      <style data-id="element-40">{`
        @keyframes comet-orbit {
          from { offset-distance: 0%; }
          to { offset-distance: 100%; }
        }
      `}</style>
    </div>;
};
export default CometCard;